import React, {useState} from 'react';
import {Link, Redirect} from 'react-router-dom';
import PersonSelects from "./PersonSelects";

interface Step2bProps {
  persons: string[];
  pSNr: {[key: string]: number};
  setPSNr: React.Dispatch<React.SetStateAction<{[key: string]: number}>>;
  s: {[key: string]: string[]};
  setS: React.Dispatch<React.SetStateAction<{[key: string]: string[]}>>;
}

function Step2b(props: Step2bProps) {
  const { persons, pSNr, setPSNr, s, setS } = props;

  const [redirectTo, setRedirectTo] = useState<string|undefined>(undefined);

  const allFieldFilled = (ids: string[]) => {
    return ids.map((id) => {
      return s[id].filter((f) => f !== '-').length > 0;
    }).every((value) => value);
  }

  const redirect = (e: React.MouseEvent<HTMLButtonElement>, to: string) => {
    e.preventDefault();

    if (!allFieldFilled(['12', '13', '14', '15', '16'])) {
      alert('Bitte alle Felder ausfüllen.');
      return;
    }

    setRedirectTo(to);
  };

  if (redirectTo !== undefined) {
    return (
      <Redirect to={redirectTo} />
    );
  }

  return (
    <div className="step step2b">
      <h2>Schritt 2: Zuständigkeiten</h2>

      <h3>B) Rechenschaft (Verantwortung)</h3>

      <p>
        Geben Sie hier bitte jeweils die Personen oder Gruppen an, die für den jeweiligen Bereich <strong>verantwortlich
        oder rechenschaftspflichtig</strong> sind oder in anderer Form
        die <strong>Konsequenzen</strong> tragen müssen.
      </p>

      <form>
        <div className="personBlock">
          <p>
            Wer muss das Problem lösen oder trägt Konsequenzen, wenn das System die Zielvorgaben nicht
            erfüllt?
          </p>
          <PersonSelects id="12" persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
        </div>
        <div className="personBlock">
          <p>
            Wer muss das Problem lösen oder trägt Konsequenzen, wenn das System nicht richtig
            implementiert wurde?
          </p>
          <PersonSelects id="13" persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
        </div>
        <div className="personBlock">
          <p>
            Wer muss das Problem lösen oder trägt Konsequenzen, wenn es zu datenschutzrechtlichen
            Beschwerden kommt?
          </p>
          <PersonSelects id="14" persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
        </div>
        <div className="personBlock">
          <p>
            Wer muss das Problem lösen oder trägt Konsequenzen, wenn die Integrität des Systems verletzt
            wurde?
          </p>
          <PersonSelects id="15" persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
        </div>
        <div className="personBlock">
          <p>
            Wer muss das Problem lösen oder trägt Konsequenzen, wenn das System falsch angewendet wird?
          </p>
          <PersonSelects id="16" persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
        </div>
      </form>

      <div className="stepNav">
        <Link className="btn btn-secondary" to="/step2a">Zurück</Link>
        <button className="btn btn-primary" onClick={(e) => redirect(e, '/step2c')}>Weiter</button>
      </div>
    </div>
  );
}

export default Step2b
;